module.exports = __webpack_public_path__ + "../resources/img/normal_process0.a2600d32.png";